import { render, staticRenderFns } from "./GstWithHoldingStatementDetail.vue?vue&type=template&id=62764562&scoped=true"
import script from "./GstWithHoldingStatementDetail.vue?vue&type=script&lang=js"
export * from "./GstWithHoldingStatementDetail.vue?vue&type=script&lang=js"
import style0 from "./GstWithHoldingStatementDetail.vue?vue&type=style&index=0&id=62764562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62764562",
  null
  
)

export default component.exports